import { z } from 'zod';
import { AgentAttemptStatus } from './enums.js';
/** Agent claims a unit of approved work (FR-508). */
export const AgentClaimInput = z.object({
    /** Optional: claim a specific ticket; otherwise claim next eligible. */
    ticketId: z.string().optional(),
    agentId: z.string().min(1),
    /** Lease time-to-live in seconds. */
    leaseTtlSeconds: z.number().int().min(30).max(3600).default(900),
});
export const AgentLease = z.object({
    ticketId: z.string(),
    ticketCode: z.string(),
    agentId: z.string(),
    leaseToken: z.string(),
    expiresAt: z.string(),
    heartbeatAt: z.string(),
});
export const AgentHeartbeatInput = z.object({
    leaseToken: z.string(),
    status: AgentAttemptStatus.optional(),
    note: z.string().optional(),
});
/** Agent posts a PR / progress artifact (FR-510). */
export const AgentArtifactInput = z.object({
    leaseToken: z.string(),
    status: AgentAttemptStatus,
    branch: z.string().optional(),
    prUrl: z.string().url().optional(),
    summary: z.string().optional(),
    changedFiles: z.array(z.string()).optional(),
    testsRun: z.string().optional(),
    riskLevel: z.enum(['low', 'medium', 'high']).optional(),
    rollbackNotes: z.string().optional(),
    followUps: z
        .array(z.object({ title: z.string(), description: z.string().optional() }))
        .optional(),
    evidenceUrls: z.array(z.string()).optional(),
});
export const AgentAttempt = z.object({
    id: z.string(),
    ticketId: z.string(),
    agentId: z.string(),
    status: AgentAttemptStatus,
    branch: z.string().nullable(),
    prUrl: z.string().nullable(),
    summary: z.string().nullable(),
    riskLevel: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=agent.js.map